import { IonApp, IonButton, IonContent, IonInput, IonPopover } from "@ionic/react";
import React, { Component } from "react";
import Footer from "../../components/Footer";
import GoogleSignin from "../../components/GoogleSignin";
import OrButton from "../../components/OrButton";
import Toolbar from "../../components/Toolbar";
import Firebase from "../../firebase";
import { REGEX } from "../../regex";
import "./style.css";

class Register extends Component {
    state = { fb: Firebase.getInstance(), popoverOpen: false, popoverMessage: "" };

    componentDidMount() {
        document.dispatchEvent(new Event("pageMount"));
    }

    render() {
        return (
            <IonApp>
                <Toolbar />
                <IonContent>
                    <IonPopover
                        isOpen={this.state.popoverOpen}
                        cssClass="register__popover"
                        onDidDismiss={(e) => {
                            this.setState({ popoverOpen: false });
                        }}
                    >
                        {this.state.popoverMessage}
                    </IonPopover>
                    <br />
                    <GoogleSignin />
                    <br />
                    <OrButton />
                    <form
                        onSubmit={async (e: any) => {
                            e.preventDefault();
                            const nickname = (document.getElementById("registerNickname") as any).value;
                            const email = (document.getElementById("registerEmail") as any).value;
                            const pass = (document.getElementById("registerPass") as any).value;
                            const pass2 = (document.getElementById("registerPass2") as any).value;
                            if (!nickname || !email || !pass || !pass2) return;
                            if (pass !== pass2) {
                                this.setState({
                                    popoverOpen: true,
                                    popoverMessage: "הסיסמות שהוזנו אינן זהות",
                                });
                                return;
                            }
                            const res = await this.state.fb.register(email, pass);
                            if (res.message) {
                                this.setState({
                                    popoverOpen: true,
                                    popoverMessage: res.message,
                                });
                                return;
                            }
                            await this.state.fb.setUserData(nickname);
                            await this.state.fb.verifyEmail();
                            window.location.pathname = "/";
                        }}
                    >
                        <IonInput
                            placeholder="כינוי"
                            id="registerNickname"
                            minlength={2}
                            maxlength={25}
                            required
                        ></IonInput>
                        <br />
                        <IonInput
                            placeholder='דוא"ל'
                            type="email"
                            id="registerEmail"
                            pattern={REGEX.email}
                            required
                            style={{ direction: "ltr" }}
                        ></IonInput>
                        <br />
                        <IonInput
                            placeholder="סיסמה"
                            type="password"
                            id="registerPass"
                            clearOnEdit={false}
                            minlength={6}
                            pattern={REGEX.password}
                            required
                            style={{ direction: "ltr" }}
                        ></IonInput>
                        <br />
                        <IonInput
                            placeholder="סיסמה שוב"
                            type="password"
                            id="registerPass2"
                            clearOnEdit={false}
                            minlength={6}
                            pattern={REGEX.password}
                            required
                            style={{ direction: "ltr" }}
                        ></IonInput>
                        <br />
                        <IonButton type="submit">רישום</IonButton>
                    </form>
                    <br />
                    <Footer />
                </IonContent>
            </IonApp>
        );
    }
}

export default Register;
